import { createSlice } from "@reduxjs/toolkit";
import { fetchDamagesItems } from "./thunk";

interface FetchDamageItemsState {
  list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: FetchDamageItemsState = {
  list: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const DamageItemsSlice = createSlice({
  name: "Damage",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDamagesItems.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDamagesItems.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchDamagesItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Draft RFQ List";
      });
  },
});

export default DamageItemsSlice.reducer;
